import { render, staticRenderFns } from "./CostsItemGeneralSelect.vue?vue&type=template&id=38424d37&"
import script from "./CostsItemGeneralSelect.vue?vue&type=script&lang=js&"
export * from "./CostsItemGeneralSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports